<template>
  <div
    class="primary-button"
    :class="{ disabled, [mode]: mode }"
    @click="click"
  >
    <div class="primary-button__icon" v-if="icon" v-html="icon"></div>
    <div class="primary-button__icon" v-else-if="withIcon">
      <slot name="icon"></slot>
    </div>

    <div class="primary-button__text">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrimaryButton',
  props: {
    icon: {
      type: String,
      default: null,
    },
    withIcon: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'default',
    },
  },
  methods: {
    click(e) {
      if (this.disabled) {
        return
      }

      this.$emit('click', e)
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.primary-button {
  padding: 13px 26px;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #ffffff;
  background: #64748B;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s linear;
  &__icon {
    height: 14px;
    margin-right: 7px;

    display: flex;
    align-items: center;
    justify-content: center;

    :deep(svg) {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &.colorLess {
    background: #e0e6f2;
    color: #64748B;
  }

  &:hover {
    opacity: 0.8;
  }

  &.disabled {
    cursor: not-allowed;
    filter: grayscale(100%);
  }
}
</style>
